import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { AppIconsGears } from "../../../AppIcons";
import { useEffect, useState } from "react";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import ServiceProvider from "../../../../configuration/ServiceProvider";
import useBrands from "../../../../../explorer/hooks/useBrands";
import { PartApplicability } from "../../../../../explorer/types/SpareParts/PartApplicability";
import useLanguages from "../../../../../explorer/hooks/useLanguages";
import {
    BasketItemDTO,
    BasketItem,
} from "../../../../../explorer/types/Basket/BasketItems";
import CodeAndDescriptionDialog from "./CodeAndDescriptionDialog";
import { useTableLayoutClasses } from "../TableLayout.style";
import useCurrentSite from "../../../../hook/useCurrentSite";
import { usePartFormatter } from "../../../../hook/usePartFormatter";

type TCodeAndDescriptionComponent = {
    item: BasketItem;
    additionalProps: any;
    
};

const CodeAndDescriptionComponent = (props: TCodeAndDescriptionComponent) => {
    const { item, additionalProps } = props;

    const [currentSite] = useCurrentSite();
    const [open, setOpen] = useState<boolean>(false);
    const [machine, setMachine] = useState<string>("");
    const [table, setTable] = useState<string>("");
    const [position, setPosition] = useState<string>("");
    const [navContext, setNavContext] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(true);
    const [applicabilities, setApplicabilities] = useState<PartApplicability[]>(
        []
    );

    const partFormatter = usePartFormatter();

    const brand = useBrands().currentBrandUrl;
    const lang = useLanguages().currentLanguage;

    const { t } = useTranslation();

    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };

    const handleChangeNavContext = async (
        navContext: string,
        valueSwitch: boolean
    ) => {
        const part: BasketItemDTO = {
            code: item.code,
            rowId: item.rowId,
            navContext: navContext,
        };

        if (valueSwitch) {
            additionalProps.handleChangeNavContext(part, "1");
        } else {
            additionalProps.handleChangeNavContext(part);
        }

        setOpen(false);
    };

    const handleOpenPartDetail = () => {
        additionalProps.setPartDetailOpen(true);
        additionalProps.openPartDetails(
            item.code,
            "",
            item.manufacturerCompanyCode,
            "",
            "",
            item.navContext,
            false
        );
    };

    useEffect(() => {
        if (
            Object.keys(currentSite).length > 0 &&
            currentSite !== undefined &&
            open
        ) {
            setLoading(true);
            ServiceProvider.SpareParts.getPartApplicabilities(
                brand,
                item.manufacturerCompanyCode,
                item.code.split("/")[0],
                lang
            )
                .then((result) => {
                    setApplicabilities(
                        result.filter(
                            (x) =>
                                x.site.customerSiteCode ===
                                currentSite.customerSiteCode
                        )
                    );
                    setLoading(false);
                })
                .catch((error) => console.error(error));
        }
    }, [open]);

    useEffect(() => {
        if (item.navContext !== undefined)
            partFormatter.getDataByNavContext(item.navContext, (m, t, p) => {
                setMachine(m);
                setTable(t);
                setPosition(p);
            });
    }, [item.navContext]);

    useEffect(() => {
        setNavContext(
            partFormatter.getNavContextByData(machine, table, position)
        );
    }, [machine, table, position]);

    const classes = useTableLayoutClasses();

    return (
        <Box key={item.code}>
            {/* Prima riga */}

            <Box sx={{ cursor: !props.additionalProps.readonly ? "pointer" : "default" }} 
            
            onClick={!props.additionalProps.readonly ? handleOpenPartDetail: undefined}
            
            >
                <Tooltip
                    title={`${
                        item.code
                    } / ${item.partDescription.toUpperCase()}`}
                    placement="right"
                    disableInteractive
                >
                    <Typography
                        variant="body2"
                        style={{ width: "fit-content" }}
                    >
                        {item.code} / {item.partDescription}
                    </Typography>
                </Tooltip>
            </Box>

            {/* Seconda riga */}

            <Box>
                <Tooltip title={item.navContext !== "" && navContext} placement="right" disableInteractive>
                    <Typography
                        variant="body2"
                        sx={
                            item.navContext !== ""
                                ? classes.machine
                                : classes.notMachine
                        }
                        className={item.navContext === "" ? "notMachine" : ""}
                    >
                        <IconButton
                            disabled={additionalProps.getPrice || additionalProps.readonly}
                            onClick={handleOpenDialog}
                            color={
                                item.navContext !== "" ? "primary" : "secondary"
                            }
                            sx={classes.hideOnPrint}
                        >
                            <AppIconsGears />
                        </IconButton>
                        {item.navContext !== ""
                            ? navContext
                            : t("common.basket.machineNotSpecified")}
                    </Typography>
                </Tooltip>
            </Box>

            <CodeAndDescriptionDialog
                open={open}
                rowId={item.rowId}
                applicabilities={applicabilities}
                navContext={item.navContext}
                loading={loading}
                code={item.code}
                handleChangeNavContext={handleChangeNavContext}
                handleCloseDialog={handleCloseDialog}
                customerSiteCode={currentSite.customerSiteCode ?? ""}
            />
        </Box>
    );
};

export default CodeAndDescriptionComponent;
